module.exports = { "default": require("core-js/library/fn/math/atanh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/atanh.js
// module id = 1397
// module chunks = 2